// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3CIKF","loaderOuter":"PageOverlayLoader_loaderOuter__23Brw"};